import { render, staticRenderFns } from "./FindPositionProStart.vue?vue&type=template&id=2f2a2fff&scoped=true&"
import script from "./FindPositionProStart.vue?vue&type=script&lang=js&"
export * from "./FindPositionProStart.vue?vue&type=script&lang=js&"
import style0 from "./FindPositionProStart.vue?vue&type=style&index=0&id=2f2a2fff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a2fff",
  null
  
)

export default component.exports